export default "__VITE_ASSET__DO9HDE3o__"